import { IRepresentacion } from "../interfaces/Representacion";
import { Operations } from "../util/types";
import { get, post } from "./fetch";

export const getListaRepresentaciones = async (idioma:string = "es"):Promise<IRepresentacion[]> => {
  //Stored Procedure: DashboardSituacion_Get_Representaciones
  var result = await get(`/api/representaciones?idioma=${idioma}`);
  return result;
};
